module.exports = __webpack_public_path__ + "static/media/me.b475ea0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/me.jpg
// module id = 60
// module chunks = 0